var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"tenant-creation"}},[_c('keep-alive',[_c(_vm.activeComponent,_vm._b({tag:"component",on:{"onChangeComponent":_vm.onChangeComponent,"onBackParent":_vm.onBackParent}},'component',{userData: _vm.userData},false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }